// extracted by mini-css-extract-plugin
export var boxItems = "_9f-1";
export var boxItemsLg = "_9f-2";
export var button = "_9f-7";
export var buttonHoverless = "_9f-9";
export var buttonLg = "_9f-8";
export var filterGroupBox = "_9f-0";
export var icon = "_9f-3";
export var iconSecondary = "_9f-6";
export var iconWrapper = "_9f-4";
export var iconWrapperLg = "_9f-5";
export var truncatedLabel = "_9f-a";